import { TweenLite, Power3 } from 'gsap/TweenMax';


export function titleIn(el) {
  const elToAnimate = el;

  const tween = TweenLite.fromTo(elToAnimate, 1, {
    y: 200,
    rotationX: 30,
    scaleY: 1.3,
    autoAlpha: 0,
    transformOrigin: '50% 0%',
  }, {
    y: 0,
    rotationX: 0,
    scaleY: 1,
    autoAlpha: 1,
    ease: Power3.easeInOut,
    clearProps: 'autoAlpha, transformOrigin, transform',
  });

  return tween;
}

export function titleInPage(el) {
  const elToAnimate = el;

  const tween = TweenLite.fromTo(elToAnimate, 1, {
    y: window.innerWidth < 1024 ? 300 : 200,
    rotationX: 30,
    scaleY: 1.5,
    scaleX: 1.2,
    autoAlpha: 0,
    transformOrigin: window.innerWidth < 1024 ? '50% 50%' : '0% 0%',
  }, {
    y: window.innerWidth < 1024 ? 125 : 0,
    rotationX: 0,
    scaleY: 1.2,
    scaleX: 1.2,
    autoAlpha: 1,
    ease: Power3.easeInOut,
    clearProps: 'autoAlpha',
  });

  return tween;
}

export function titleOut(el) {
  const elToAnimate = el;

  const tween = TweenLite.fromTo(elToAnimate, 0.7, {
    y: 0,
    rotationX: 0,
    scaleY: 1,
    autoAlpha: 1,
  }, {
    y: -200,
    rotationX: -15,
    scaleY: 1.1,
    autoAlpha: 0,
    ease: Power3.easeInOut,
    clearProps: 'autoAlpha, transformOrigin, transform',
  });

  return tween;
}

export function titleZoom(el, orienting = 'in') {
  const elToAnimate = el;
  const scaleEnd = orienting === 'in' ? 1.3 : 1;
  let tween = null;

  if (orienting === 'in') {
    tween = TweenLite.to(elToAnimate, 1, {
      transformOrigin: window.innerWidth < 1024 ? '50% 50%' : '0% 0%',
      y: window.innerWidth < 1024 ? 125 : 0,
      scale: scaleEnd,
      ease: Power3.easeInOut,
    });
  } else {
    tween = TweenLite.to(elToAnimate, 1, {
      y: 0,
      transformOrigin: window.innerWidth < 1024 ? '50% 50%' : '0% 0%',
      scale: scaleEnd,
      ease: Power3.easeInOut,
    });
  }

  return tween;
}

export function textIn(el) {
  const elToAnimate = el;

  const tween = TweenLite.fromTo(elToAnimate, 1, {
    y: 100,
    scaleY: 2.5,
    autoAlpha: 0,
  }, {
    scaleY: 1,
    y: 0,
    autoAlpha: 1,
    ease: Power3.easeInOut,
    clearProps: 'autoAlpha, transform',
  });

  return tween;
}

export function yearIn(el) {
  const elToAnimate = el;

  const tween = TweenLite.fromTo(elToAnimate, 1, {
    y: -80,
    rotationX: -30,
    scaleY: 1.3,
    autoAlpha: 0,
    transformOrigin: '50% 100%',
  }, {
    y: 0,
    rotationX: 0,
    scaleY: 1,
    autoAlpha: 1,
    ease: Power3.easeInOut,
    clearProps: 'autoAlpha, transform',
  });

  return tween;
}

export function yearOut(el) {
  const elToAnimate = el;

  const tween = TweenLite.fromTo(elToAnimate, 1, {
    y: 0,
    rotationX: 0,
    scaleY: 1,
    autoAlpha: 1,
    ease: Power3.easeInOut,
    transformOrigin: '50% 0%',
  }, {
    y: -80,
    rotationX: -30,
    scaleY: 1.3,
    autoAlpha: 0,
    clearProps: 'autoAlpha, transform',
  });

  return tween;
}

export function paragraphIn(el) {
  const elToAnimate = el;

  const tween = TweenLite.fromTo(elToAnimate, 1, {
    y: 100,
    rotationX: 30,
    scaleY: 1.3,
    autoAlpha: 0,
    transformOrigin: '50% 0%',
  }, {
    y: 0,
    rotationX: 0,
    scaleY: 1,
    autoAlpha: 1,
    ease: Power3.easeOut,
    clearProps: 'autoAlpha, transformOrigin, transform',
  });

  return tween;
}

export function paragraphOut(el) {
  const elToAnimate = el;

  const tween = TweenLite.to(elToAnimate, 0.8, {
    y: 100,
    rotationX: 30,
    scaleY: 1.3,
    autoAlpha: 0,
    transformOrigin: '50% 0%',
    clearProps: 'transform',
    ease: Power3.easeOut,
  });

  return tween;
}

export function paragraphInit(el) {
  const elToAnimate = el;

  const tween = TweenLite.set(elToAnimate, {
    scaleY: 1.3,
    autoAlpha: 0,
    transformOrigin: '50% 0%',
  });

  return tween;
}
